import { APIModel } from "./api-model";

export class CoordinatorNote extends APIModel {
  id: string;
  note: string;

  static fieldsToMap = {
    direct: [
      'note'
    ]
  }

  static buildFromAPI(record: any): CoordinatorNote {
    const row = new CoordinatorNote();
    record = record || {};

    this.mapFieldsDirectly<CoordinatorNote>(CoordinatorNote.fieldsToMap.direct, record, row);

    return row
  }
}